import { Locale } from "@/shared/i18n/config";

export const DATE_FORMAT: Record<Locale, string> = {
  en: "MM/DD/YYYY",
  ru: "DD.MM.YYYY",
  kz: "DD.MM.YYYY",
  uz: "DD.MM.YYYY",
};

export const DATE_TIME_FORMAT: Record<Locale, string> = {
  en: "MM/DD/YYYY HH:mm",
  ru: "DD.MM.YYYY HH:mm",
  kz: "DD.MM.YYYY HH:mm",
  uz: "DD.MM.YYYY HH:mm",
};
